import { Box, Button, CssBaseline, Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useContext, useEffect, useRef, useState } from 'react'
import TwoHeadTable from '../../../../../../components/TwoHeadTable'
import EnergyReportingLogTable from '../../../../../../components/charts/energy_reporting/EnergyReportingLogTable'
import { InverterContext } from '../../../../../../context/InverterContext'
import Pagination from '../../../../../../components/general/Pagination'
import ExportContent from '../../../../../../components/ExportContent'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { getDateTimeForDashboardTab1, getFromTo } from '../../../../../../utils'
import generatePDF from 'react-to-pdf'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TopHeader from '../../../../../../components/general/TopHeader'
import { PASS_KEY, WEB_KEY } from '../../../../../../api/AxiosApi'
let TableHeading
function DailyEnergyLogs() {
    const { InverterChartData, getInverterChartData } = useContext(InverterContext)
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay)
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today)
    const LOC_CODE = localStorage.getItem('LCODE')
    const LOGIN_ID = localStorage.getItem("LoginID") ?? ""
    const STYPE= "ALL"


    if (InverterChartData?.length > 0) {
        const data = InverterChartData[0]
        TableHeading = Object.keys(data)
    }
    useEffect(() => {
        getInverterChartData(LOGIN_ID,LOC_CODE,WEB_KEY,PASS_KEY,STYPE, StartDate, EndDate)
    }, [])


    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            getInverterChartData(LOGIN_ID,LOC_CODE,WEB_KEY,PASS_KEY,STYPE, StartDate, EndDate)
        } else {
            alert('please provide any date')
        }

    }

    return (
        <>
            {/* <TopHeader/> */}
            <EnergyReportingLogTable
                onRefreshData={onRefreshData}
                TableData={InverterChartData}
                TableHead={TableHeading}
                ValueOf1={StartDate}
                ValueOf2={EndDate}
                onChangeValueOF1={(val) => setStartDate(val.target.value)}
                onChangeValueOF2={(val) => setEndDate(val.target.value)}
                radiationName={'Daily Energy Logs'}
            />
        </>


    )
}

export default DailyEnergyLogs


